import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import get from 'lodash/get.js';
import PendoIcon from '../icon/pendo-icon.vue.js';
import PendoRadio from '../radio/pendo-radio.vue.js';
import PendoTooltip from '../../directives/tooltip/pendo-tooltip.js';

var script = {
  name: 'PendoRadioButton',
  components: {
    PendoRadio,
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  inject: {
    $formItem: {
      default: ''
    },
    $radioGroup: {
      default: ''
    }
  },
  props: {
    value: {
      type: null,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    icon: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledLabel: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null,
      validator: size => ['mini', 'small', 'medium'].includes(size)
    }
  },
  computed: {
    iconProps() {
      return _objectSpread2({
        size: 14
      }, this.icon);
    },
    tooltipContent() {
      if (!this.icon) {
        return null;
      }
      if (this.disabled) {
        return this.disabledLabel;
      }
      return this.label;
    },
    radioSize() {
      const groupSize = get(this, '$radioGroup.radioGroupSize');
      return groupSize || this.size;
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-radio-button.vue2.js.map
